import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { StudentListStyle } from './style'
import Text from '@components/Text'
import Button from '@components/Button'
import { COLORS, PANELS, SCHOOL_RESOURCE_TYPES } from '@helpers/constants'
import Loader from '@components/Loader'
import { useDeleteCustomer } from '@hooks/mutations/useDeleteCustomer'
import { useConfirm } from '@hooks/useConfirm'
import { mutate } from 'swr'
import { Single_SchoolClass } from '@graphql/queries'
import { useCurrentUser } from '@hooks/useCurrentUser'
import { AppContext } from '@state/context'
import { openPanelWithData } from '@state/actions/panelsActions'
import { setSelectedStudent } from '@state/actions/appActions'
import { useExamsAllowed } from '@hooks/useExamsAllowed'

const StudentListItem = (props) => {
  const {
    item,
    label,
    updateHook,
    resourceId,
    resourceType,
    hideRemoveButton = false,
  } = props
  const [state, dispatch] = useContext(AppContext)

  const {
    app: { selectedStudent },
  } = state

  const isSelected = selectedStudent?.id === item.id

  const [isHovering, setIsHovering] = useState(false)
  const { confirm } = useConfirm()
  const { post, isPosting } =
    resourceType === SCHOOL_RESOURCE_TYPES.CLASS
      ? useDeleteCustomer()
      : updateHook()
  const { currentUser } = useCurrentUser()

  const deleteStudent = async (id) => {
    const confirmed = await confirm({
      title: label,
      text: 'Är du säker på att du vill radera den här elevens konto?',
      confirmText: 'Ja, ta bort eleven',
      cancelText: 'Avbryt',
    })
    if (!confirmed) return

    dispatch(setSelectedStudent(null))

    const res = await post(
      { id },
      'Elev borttagen.',
      'Nåt gick fel när eleven skulle tas bort.'
    )
    if (res.success) {
      mutate([Single_SchoolClass, resourceId])
    }
  }
  const disconnectStudent = async (id) => {
    dispatch(setSelectedStudent(null))

    await post(
      {
        id: resourceId,
        students: { disconnect: [id] },
      },
      'Elev borttagen.',
      'Nåt gick fel när eleven skulle tas bort.'
    )
  }

  const examsAllowed = useExamsAllowed()

  return (
    <li
      className={`${
        examsAllowed && isSelected
          ? StudentListStyle.activeListItem
          : StudentListStyle.listItem
      }`}
      onMouseEnter={() => {
        if (!isPosting) setIsHovering(true)
      }}
      onMouseLeave={() => {
        if (!isPosting) setIsHovering(false)
      }}
      onClick={() => {
        if (examsAllowed) {
          dispatch(setSelectedStudent(item))
        }
      }}
    >
      <Text>{label}</Text>
      <div className={StudentListStyle.removeButtonWrapper}>
        {resourceType === SCHOOL_RESOURCE_TYPES.CLASS &&
          !currentUser?.hasValidPubAgreement &&
          isHovering && (
            <Button
              icon={'Key'}
              textColor={COLORS.WHITE.TEXT}
              backgroundColor={COLORS.DARK_GREY.BACKGROUND}
              handleClick={() => {
                dispatch(
                  openPanelWithData({
                    panel: PANELS.HANDLE_STUDENT_PASSWORD,
                    data: { student: item },
                  })
                )
              }}
              classes={StudentListStyle.removeButton}
            />
          )}
        {!hideRemoveButton && isHovering && (
          <Button
            icon={
              resourceType === SCHOOL_RESOURCE_TYPES.CLASS
                ? 'TrashCan'
                : 'CloseSmall'
            }
            textColor={COLORS.WHITE.TEXT}
            backgroundColor={COLORS.DARK_GREY.BACKGROUND}
            handleClick={() => {
              setIsHovering(false)
              resourceType === SCHOOL_RESOURCE_TYPES.CLASS
                ? deleteStudent(item.id)
                : disconnectStudent(item.id)
            }}
            classes={StudentListStyle.removeButton}
          />
        )}
        {isPosting && (
          <div className={StudentListStyle.loaderWrapper}>
            <Loader noMargin />
          </div>
        )}
      </div>
    </li>
  )
}

StudentListItem.propTypes = {
  item: PropTypes.object,
  label: PropTypes.string,
  updateHook: PropTypes.func,
  resourceId: PropTypes.string,
  resourceType: PropTypes.string,
  hideRemoveButton: PropTypes.bool,
}

export default StudentListItem
